import React from 'react';
import "babel-polyfill";
import ImageCompressor from 'image-compressor.js';
import sharedStyles from '../util/sharedStyles';

export default class Cropper extends React.Component {

  state = {
    imageUploadBase64: null,
    showCroppie: false,
  }

  componentDidMount() {
    const wW = $('.croppieEl').parent().width();
    const outerViewportW = wW
    const outerViewportH = Math.round(wW * 0.74)
    const viewportW = Math.round(wW * 0.75)
    // const viewportH = Math.round(viewportW * 0.54)
    const viewportH = Math.round(viewportW * 0.7)
    
    this.croppieImg = new Croppie($('.croppieEl').get(0), {
      viewport: { width: viewportW, height: viewportH },
      boundary: { width: outerViewportW, height: outerViewportH },
      update: this._crop,
      enableOrientation: true
    });

    $(".cr-slider-wrap").prepend("<a class='decrement'>-</a>")
    $(".cr-slider-wrap").append("<a class='increment'>+</a>")
    
    $(".cr-slider-wrap").on("click", "a.decrement", (e) => {
      e.preventDefault()
      const currentZoom = this.croppieImg.get().zoom
      this.croppieImg.setZoom(currentZoom - 0.1)
    })
    $(".cr-slider-wrap").on("click", "a.increment", (e) => {
      e.preventDefault()
      const currentZoom = this.croppieImg.get().zoom
      this.croppieImg.setZoom(currentZoom + 0.1)
    })
  }

  _crop = () => {
    this.croppieImg.result({
      type: 'canvas',
      size: 'original',
      format: 'jpeg',
      quality: 1
    })
    .then((base64Image) => {
      this.props.updateCroppedBase64(base64Image, "image/jpeg")
    });
  }

  handleRotate = (e) => {
    this.croppieImg.rotate(90)
  }

  handleUpload = async (e) => {
    const files = e.target.files;
    let file = files[0];
    const imageCompressor = new ImageCompressor();
    const reader = new FileReader();

    file = await imageCompressor.compress(file, {
      quality: 1,
      maxWidth: 1200,
      maxHeight: 1200
    })

    reader.addEventListener("load", () => {
      this.setState({ 
        imageUploadBase64: reader.result,
        showCroppie: true
      })
      this.croppieImg.bind({
        enableOrientation: true,
          url: reader.result,
          orientation: 1
        })
    }, false);

    if (file) {
      reader.readAsDataURL(file);
    }
  }

  handleSave = async (e) => {
    this.props.generatePreview()
    $(".Collapsible__trigger").get(1).click()
  }

  render() {
    return (
      <React.Fragment>
        <label for="labelUpload" className="labelUpload-button action-button" style={{width: this.state.showCroppie ? "50%" : "100%", textAlign: "center"}}>
          {this.props.translations["upload-image"]}
        </label>
        <input onChange={this.handleUpload} type="file" id="labelUpload" accept="image/*" style={{display: 'none'}} />
        
        <a
          onClick={this.handleRotate}
          href="javascript:void(0);"
          style={{ textAlign: "center", display: this.state.showCroppie ? "block" : "none" }}
          className="rotate-button"></a>

        <div className="upload-disclaimer" style={{fontSize: "11px", textAlign: "center", marginTop: "5px"}}>
          {this.props.translations["upload-disclaimer"]}
        </div>

        <div className="croppieEl" style={{marginTop: "10px", display: this.state.showCroppie ? "block" : "none"}}></div>

        {this.props.errorMsg && 
          <p style={{color: "red"}}>{this.props.errorMsg}</p>
        }

        <a
          onClick={this.handleSave} 
          href="javascript:void(0);" 
          style={{textAlign: "center", display: this.state.showCroppie ? "block" : "none"}}
          className="action-button">Save</a>
        
      </React.Fragment>
    )
  }
}